import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.css']
})
export class ListComponent implements OnInit {

  @Input() object: any;
  public richText: any;
  public listText: any; 

  constructor() { }

  ngOnInit(): void {
    console.log(this.object);
    this.richText = this.object.textresponse;
    this.listText = this.richText.list;
  }

}
